import client from '@/client/apiClient';
import GameWeek from '@/models/GameWeek/gameWeek';

export default class GameWeekService {
  static getGameWeeks() {
    return client
      .get('/game-weeks', { cache: true })
      .then((response) => GameWeek.createCollectionFromObject(response.data));
  }

  static closeGameWeek(gameWeekNumber) {
    return client.post(`/game-weeks/${gameWeekNumber}/close`)
      .then((response) => GameWeek.createFromObject(response.data));
  }

  static openGameWeek(gameWeekNumber) {
    return client.post(`/game-weeks/${gameWeekNumber}/open`)
      .then((response) => GameWeek.createFromObject(response.data));
  }
}
